import { Pressable } from "@-/com.npmjs.react-native";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import {
  LevelSurfaceHeader,
  type LevelSurfaceHeaderProps,
} from "@-/dev.improve.haniverse.routes.nav.app._components.level.surface";
import {
  getLevelSurfaceKey,
  type LevelSurfacePart,
} from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels._context";

/**
 * Expands a level's compact glyph tiles into detailed tiles, or collapses them again.
 * The header's own press still opens the level details sheet.
 */
export function LevelDetailsSurfaceHeader({
  expanded,
  onExpandedChange,
  part = "character",
  ...headerProps
}: LevelSurfaceHeaderProps & {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  part?: LevelSurfacePart;
}) {
  const surfaceKey = getLevelSurfaceKey(headerProps.level.index, part);
  const label = headerProps.label ?? `Level ${headerProps.level.index + 1}`;
  return (
    <LevelSurfaceHeader
      {...headerProps}
      trailing={
        <Pressable
          accessibilityLabel={`${expanded ? "Collapse" : "Expand"} cards for ${label}`}
          accessibilityRole="button"
          accessibilityState={{ expanded }}
          className="size-11 items-center justify-center rounded-xs active:bg-accent"
          onPress={() => onExpandedChange(!expanded)}
          testID={`level-details-toggle-${surfaceKey}`}
        >
          <Icon
            className="text-muted-foreground"
            name={expanded ? "MdRemove" : "MdAdd"}
            size={22}
          />
        </Pressable>
      }
    />
  );
}
